import { Component } from '@angular/core';

@Component({
  selector: 'app-ppp-admin-delete-creche-dialog',
  templateUrl: './delete-creche-dialog.component.html'
})
export class DeleteCrecheDialogComponent {

}
